import React from 'react';
import { Dialog, Divider, Slide } from '@mui/material';
import { useMessagingContext, useSelectedConversation } from '../MessagingProvider.component';
import { ConversationsList } from '../ConversationsSidebar/ConversationsList.component';
import { Color } from '../types';
import { Messages } from '../Messages';
import { ArrowBack } from '@mui/icons-material';
import { MessagingNoticeModal } from '../Messages/MessagingNotice.component';
import { DialogActionButton, MessagingDialogTitle } from './DesktopMessagingDialog';


export type MessagingModalProps = {
  color?: Color;
  onOpenToDosClick?: () => void;
  includeToDos?: boolean;
};


export const MobileMessagingDialog: React.FC = ({ children }) => {
  const messaging = useMessagingContext();

  return (
    <Dialog
      data-testid="messaging-modal"
      open={messaging.modalOpened}
      onClose={messaging.closeModal}
      fullScreen
      slots={{ transition: Slide }}
      slotProps={{
        transition: {
          direction: 'up',
          onExited: () => messaging.setSelectedConversationId(undefined),
        },
      }}
    >
      {children}
      <MessagingNoticeModal />
    </Dialog>
  );
};


export const MobileMessagingContent: React.FC<MessagingModalProps> = ({ onOpenToDosClick, color = 'secondary', includeToDos = false }) => {
  const messaging = useMessagingContext();
  const selectedConversation = useSelectedConversation();

  return (
    <>
      <MessagingDialogTitle
        title="Messages"
        actions={selectedConversation ? (
          <DialogActionButton
            onClick={() => messaging.setSelectedConversationId(undefined)}
            Icon={ArrowBack}
          >
            Back
          </DialogActionButton>
        ) : null}
      />
      <Divider />
      {selectedConversation ? (
        <Messages
          conversation={selectedConversation}
          color={color}
          includeToDos={includeToDos}
        />
      ) : (
        <ConversationsList
          onOpenToDosClick={onOpenToDosClick}
          selectedConversationId={messaging.selectedConversationId}
          setSelectedConversationId={messaging.setSelectedConversationId}
          color={color}
        />
      )}
    </>
  );
};
